const DEFAULT_TIMEZONE = "Asia/Kolkata";

export function getRestaurantTimezone(timezone) {
  const tz = (timezone || "").toString().trim();
  return tz || DEFAULT_TIMEZONE;
}

export function formatDateTimeInTimezone(
  dateInput,
  timezone = DEFAULT_TIMEZONE,
  locale = "en-GB",
) {
  const d = dateInput instanceof Date ? dateInput : new Date(dateInput);
  if (Number.isNaN(d.getTime())) return "-";

  const tz = getRestaurantTimezone(timezone);
  try {
    return d.toLocaleString(locale, {
      timeZone: tz,
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } catch {
    return d.toLocaleString(locale);
  }
}

export function getRestaurantTodayDate(timezone = DEFAULT_TIMEZONE) {
  const d = new Date();
  const tz = getRestaurantTimezone(timezone);
  try {
    return new Intl.DateTimeFormat("en-CA", {
      timeZone: tz,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(d);
  } catch {
    return d.toISOString().slice(0, 10);
  }
}
